import React from 'react'
import propTypes from 'prop-types'

export default function CardFeatures({ img, label, w, h, onClick }) {
  return (
    <div
      className="group cursor-pointer wrapper w-full px-[40px] text-center py-11 border border-borderCardFeatures hover:border-primary  rounded-2xl flex flex-col justify-center items-center hover:bg-cardFeaturesHover  transition-all duration-300"
      onClick={onClick}
    >
      <svg
        width={w ? w : 64}
        height={h ? h : 49}
        viewBox={`0 0 ${w} ${h}`}
        className={`w-[${w}px] h-[${h}px] group-hover:fill-primary`}
        fill="#616161"
        xmlns="http://www.w3.org/2000/svg"
      >
        {img}
      </svg>
      <p className="w-full mt-10 text-base font-semibold text-cardText group-hover:text-primary">
        {label}
      </p>
    </div>
  );
}

CardFeatures.propTypes = {
    img: propTypes.string.isRequired,
    label: propTypes.string.isRequired,
}
